const SET_IS_TOTAL_GENERATING_IN_PROCESS = "SET_IS_TOTAL_GENERATING_IN_PROCESS";

export default {
  SET_IS_TOTAL_GENERATING_IN_PROCESS,
};
